import React from "react";
import * as S from "../style";

import logo from "../../../../app/assets/images/logo-grey.svg";

function FullPageLoader({ fullPage }) {
    return (
        <S.FullPageLoaderWrapper fullPage={fullPage}>
            <img
                src={logo}
                alt="ILLA Logo"
            />
            <S.HideBodyOverflow />
        </S.FullPageLoaderWrapper>
    );
}

export default FullPageLoader;
